module.exports = __webpack_public_path__ + "img/darktheme.d32ab498.png";